import { JSX } from "react";

import Alert from "@mui/material/Alert";

import AlertMessage from "./AlertMessage";

export type AlertBannerProps = {
	alert?: AlertMessage | null;
	onClose?: () => void;
};

export default function AlertBanner(
	props: Readonly<AlertBannerProps>
): JSX.Element {
	if (!props.alert) {
		return <></>;
	}

	return (
		<Alert severity={props.alert.severity} onClose={props.onClose}>
			{props.alert.message}
		</Alert>
	);
}
